exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".displayToggleControl{position:relative;padding-bottom:10px}.displayToggleControl a.toggleOp{padding-left:12px;padding-right:12px;padding-bottom:2px;text-decoration:none}.displayToggleControl.barMode a.toggleOp{color:inherit}.displayToggleControl.linkMode a.toggleOp:hover{opacity:.7}.displayToggleControl.linkMode a.toggleOp.activeOp{color:#aaa}.displayToggleControl.linkMode a.toggleOp:first-child{padding-left:0}.displayToggleControl.linkMode a.toggleOp:last-child{padding-right:0}.displayToggleControl .activeBar{position:absolute;top:25px;height:2px;background-color:#aaa;transition:left .15s,width .15s}.displayToggleControl .badge{position:absolute;bottom:14px;font-size:9px;font-weight:400;background-color:#70d544}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/utility/display_toggle_control.scss
// module id = 1438
// module chunks = 0